import { FooterContent, FooterContainer } from './styles';

export function Footer() {

    return (
        <FooterContent>
            <FooterContainer>
                <div>
                    <a href="/"> Jonas Borges </a>

                    <nav>
                        <ul>
                            <li><a href="#about">Sobre</a></li>
                            <li><a href="#skills">Skills</a></li>
                            <li><a href="#portfolio">Portifolio</a></li>
                            <li><a href="#testimonials">Depoimentos</a></li>
                        </ul>
                    </nav>

                    <ul>
                        <li>
                            <a href="https://www.instagram.com/jonas.borges93" target="_blank" rel="noopener noreferrer">
                                <i className="uil uil-instagram"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/in/jonasborges93/" target="_blank" rel="noopener noreferrer">
                                <i className="uil uil-linkedin-alt"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://github.com/jonasborges93" target="_blank" rel="noreferrer">
                                <i className="uil uil-github-alt"></i>
                            </a>
                        </li>
                    </ul>

                    <p>
                        <span>{new Date().getFullYear()} </span>
                        - Jonas Borges. Todos os direitos reservados
                    </p>
                </div>
            </FooterContainer>
        </FooterContent>
    )
}